<template>
  <div class="d-flex flex-column">
      <div class="px-2">
        <div class="d-flex mt-2">
          <div class="flex-1">
            <div class="d-flex">
              <el-input class="py-2" v-model="searchKey" @input="searchContact()" placeholder="Tìm kiếm bạn bè" />
              <div class="mx-1" />
            </div>
            <div class="add-group-contact-scr">
              <div v-for="(contact,index) in contactView" :key="index">
                <div class="d-flex py-2">
                  <el-checkbox :value="checkSelectedContact(contact.uid)"
                               @change="selectItem(contact)" />
                  <el-avatar :size="24" :src="contact.avatar" class="mx-2" />
                  <div class="flex-1 font-size-16 text-1-line">{{ contact.displayName }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-1 px-2">
            <div class="font-size-16 fw-bold">Đã chọn ( {{ items.length }} )</div>
            <div class="add-group-con-scr">
              <div v-for="(contact,index) in items" :key="index">
                <div class="d-flex py-2">
                  <el-checkbox :value="true" @change="unSelect(contact.uid)" />
                  <el-avatar :size="24" :src="contact.avatar" class="mx-2" />
                  <div class="flex-1 font-size-16 text-1-line">{{ contact.displayName }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="divider-custom" />
        <div class="d-flex justify-content-end mt-1">
          <el-button type="danger" size="md" @click="closeDialog()">Hủy</el-button>
          <el-button type="primary" size="md" @click="add()">Thêm thành viên</el-button>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "AddMember",
  props: ["conversation", "members"],
  data() {
    return {
      searchKey: "",
      contactView: [],
      items: [],
    };
  },

  methods: {
    closeDialog(){
      this.$bus.$emit("closeDialogMember");
      this.$emit("close");
    },

    getContacts() {
      this.$http
        .get("/api/contact/filter", {
          params: {
            searchKey: "",
            accountId: this.conversation.accountId,
            page: 0,
            pageSize: 10000
          }
        })
        .then(resp => {
          this.contactList = resp.data.content;
          this.contactView = this.contactList.filter(s => !this.members.map(s => s.id).includes(s.uid));
        });
    },
    add() {
      let membersId = this.items.map(p => {
        return p.uid;
      });
      if (membersId.length === 0) {
        return this.alert("error", "Bạn chưa chọn thành viên");
      }
      let body = {
        groupId: this.conversation.toId,
        accountId: this.conversation.accountId,
        membersId: membersId
      };
      this.$http.post("/api/conversation/inviteMembers", body).then((resp) => {
        if (resp.data.error_message === "Successful.") {
          this.alert("success", "Thêm thành công");
        } else {
          this.alert("error", "Xin thử lại");
        }
        this.closeDialog();
      });
    },
    searchContact() {
      if (this.searchKey.length > 0) {
        this.contactView = this.listAddMember().filter(p => p.displayName.toLowerCase().includes(this.searchKey.toLowerCase()));
      } else {
        this.contactView = this.listAddMember();
      }
    },
    selectItem(contact) {
      let filter = this.items.filter((con) => con.uid == contact.uid);
      if (filter != null && filter.length > 0) {
        const index = this.items.indexOf(filter[0]);
        if (index > -1) {
          this.items.splice(index, 1);
        }
      } else {
        this.items.push(contact);
      }
    }, unSelect(contactId) {
      let filter = this.items.filter((con) => con.uid == contactId);
      if (filter != null && filter.length > 0) {
        const index = this.items.indexOf(filter[0]);
        if (index > -1) {
          this.items.splice(index, 1);
        }
      }
    },
    checkSelectedContact(id) {
      let filter = this.items.filter((con) => con.uid == id);
      return filter != null && filter.length > 0;

    },
    listAddMember() {
      return this.contactList.filter(s => !this.members.map(s => s.id).includes(s.uid));
    }
  },
  created() {
    this.getContacts();

  }
};
</script>

<style scoped>

</style>